module.exports = __webpack_public_path__ + "static/media/linea_fija_icon.54268f28.svg";